if (!customElements.get('product-fuel')) {
  customElements.define('product-fuel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-fuel-open]');
      this.trigger.addEventListener('click', () => this.open(), options);
      this.querySelector('[data-fuel-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => this.restore(), options);
    }

    open() {
      if (this.dialog.open) return;
      this.scrollY = window.scrollY;
      this.bodyStyle = {};
      for (const key of ['position', 'top', 'left', 'right', 'width']) this.bodyStyle[key] = document.body.style[key];
      this.dialog.showModal();
      Object.assign(document.body.style, { position: 'fixed', top: `-${this.scrollY}px`, left: '0', right: '0', width: '100%' });
    }

    restore() {
      if (!this.bodyStyle) return;
      Object.assign(document.body.style, this.bodyStyle);
      this.bodyStyle = null;
      window.scrollTo({ top: this.scrollY, behavior: 'instant' });
      if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.restore();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
